
// Update usd accecpt payment flow

import React, { useState } from "react";

export default function PaymentButton({
  cartItems,
  totalForPayment,
  currencySymbol = "$",
  billingDetails,
}) {
  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    if (
      currencySymbol !== "$" &&
      currencySymbol !== "USD" &&
      currencySymbol !== "usd"
    ) {
      return alert("Only USD payments are accepted.");
    }

    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem("user"));
      if (!user) return alert("Please login first!");
      if (!cartItems.length) return alert("No courses to purchase.");

      // map cart items (same idea as cashfree)
      const mappedItems = cartItems.map((item) => ({
        courseId: item.courseId,
        levelId: item.levelId,
        courseTitle: item.courseTitle,
        mode: item.mode,
        actualAmount: item.fullAmount,
        amount: totalForPayment, // 👈 exact user payment for this item
        remainAmount: item.remainAmount || 0,
        currency: "USD",
      }));

      const payload = {
        uid: user.uid,
        email: user.email,
        phone: user.phone || "9999999999",
        items: mappedItems,
        currency: "usd",
        totalAmount: totalForPayment,
        billingDetails: {
          fullname: billingDetails?.fullname || "",
          address: billingDetails?.address || "",
          isMember: billingDetails?.isMember || "No",
          memberNumber: billingDetails?.memberNumber || "",
        },
      };

      // Save for backend verify (if ever needed later)
      localStorage.setItem("payload", JSON.stringify(payload));
      localStorage.setItem("verify_user", localStorage.getItem("user"));

      // 👉 CREATE STRIPE CHECKOUT SESSION
      const response = await fetch(
        "https://agepcoatings.com/payments/createorder_stripe",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      if (!data.success) return alert(data.message || "Order creation failed");

      // 👉 REDIRECT TO STRIPE PAYMENT PAGE (like Cashfree redirect)
      window.location.href = data.checkoutUrl;
    } catch (err) {
      console.error("Payment error:", err);
      alert("Something went wrong during payment!");
    } finally {
      setLoading(false);
    }
  };

  const isCartEmpty = !cartItems.length || totalForPayment <= 0;

  if (isCartEmpty) {
    return (
      <div style={{ color: "red", marginTop: "10px", textAlign: "center" }}>
        Your cart is empty
      </div>
    );
  }

  return (
    <button
      onClick={handlePayment}
      disabled={loading || !cartItems.length}
      className="payment-btn"
    >
      {loading
        ? "Processing..."
        : `Pay ${currencySymbol}${totalForPayment?.toFixed(2) || "0.00"}`}
    </button>
  );
}
